export default "__VITE_PUBLIC_ASSET__d9cb5e78__"